import axios from 'axios'
import { Dialog, Toast } from 'vant'
import Cookie from 'js-cookie'

// 创建axios实例
const service = axios.create({
  timeout: 30000 // 默认请求超时时间 30秒
})

let userToken = Cookie.get('user_token', {domain: process.env.COOKIES_DOMAIN})
let firstAttribute = Cookie.get('firstAttribute', {domain: process.env.COOKIES_DOMAIN})
let avgAttribute = Cookie.get('avgAttribute', {domain: process.env.COOKIES_DOMAIN})
let avgAttributeTime = Cookie.get('avgExpiresTime', {domain: process.env.COOKIES_DOMAIN})

service.defaults.headers.common['User-Token'] = userToken === undefined ? '' : userToken
service.defaults.headers.common['First-Attribute'] = firstAttribute === undefined ? '' : firstAttribute
service.defaults.headers.common['Avg-Attribute'] = avgAttribute === undefined ? '' : avgAttribute
service.defaults.headers.common['Avg-Expires-Time'] = avgAttributeTime === undefined ? '' : avgAttributeTime

service.defaults.headers.common['Sensors-Platform'] = 'USER_WEB'
service.defaults.headers.common['Platform'] = 'USER_WEB'

// 登录回跳
const nowUrl = window.location.href
let backUrl = '/user/login'
if (nowUrl.indexOf('user/login') === -1) {
  backUrl = '/user/login?goto=' + nowUrl
}

Toast.setDefaultOptions({ duration: 1000, className: 'toast-loading' })

const startLoading = () => {
  Toast.loading({
    message: '加载中...',
    forbidClick: true
  })
}

// 声明一个数组用于存储每个ajax请求的url标识 防止重复提交
const pending = {}
const CancelToken = axios.CancelToken
const removePending = (key, isRequest = false) => {
  if (pending[key] && isRequest) {
    pending[key]('取消重复请求')
  }
  delete pending[key]
}
const getRequestIdentify = (config) => {
  return encodeURIComponent(config.url + JSON.stringify(config.data))
}

// request拦截器

service.interceptors.request.use(
  config => {
    if (config.method === 'post' || config.method === 'delete' || (config.axiosCustomConfig || {}).startLoading === true) {
      startLoading()
      // 拦截重复请求(即当前正在进行的相同请求)
      const requestData = getRequestIdentify(config)
      removePending(requestData, true)

      config.cancelToken = new CancelToken((c) => {
        pending[requestData] = c
      })
    }

    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)
// response 拦截器
service.interceptors.response.use(function (response) {
  if (response.config.method === 'post' || response.config.method === 'delete' || (response.config.axiosCustomConfig || {}).startLoading === true) {
    // 把已经完成的请求从 pending 中移除
    const requestData = getRequestIdentify(response.config)
    removePending(requestData)
  }
  /**
   * 下载文件请求 直接返回 不要判断为json
   */
  if (response.request.responseType === 'blob') {
    return response.data
  }

  /**
   * code不存在老接口问题
   */
  // hasOwnProperty json字符串中是否存在某个字段
  const checkCode = response.data
  if (!checkCode.hasOwnProperty('code')) {
    return response
  }

  /**
   * code为非0是抛错
   */
  const res = response.data
  if (res.code !== 0) {
    // 40100:非法的token Token 过期了; xxxx:其他客户端登录了;
    if (res.code === 40100) {
      Dialog.alert({
        message: '用户登录超时,请重新登录'
      }).then(() => {
        console.log('nowUrl' + nowUrl)
        if (nowUrl.indexOf('user/collect-coupon') > 0) {
          window.location.href = nowUrl + '&scene=reload'
          return ''
        }
        window.location.href = backUrl
      })
    } else if (res.code === 40104) {
      Dialog.alert({
        message: res.msg
      }).then(() => {
        window.location.href = '/user/login?&sob=1'
      })
    } else if (res.code === 40106) {
      response.data.code = 40106
      response.data.msg = res.msg
      return response.data
    } else {
      if (!response.config.axiosCustomConfig) {
        Dialog.alert({
          message: res.msg
        }).then(() => {
        })
      }
    }
    return Promise.reject(res)
  } else {
    return response.data
  }
}, function (error) {
  let errormessage = ''
  if (error.response) {
    switch (error.response.status) {
      case 302:
        errormessage = '请求错误302'
        break
      case 400:
        if (error.response.data.msg) {
          errormessage = error.response.data.msg
        } else {
          errormessage = '请求错误400'
        }
        break
      case 401:
        errormessage = '未授权，请登录'
        break
      case 403:
        errormessage = '拒绝访问'
        break
      case 404:
        errormessage = '请求地址出错'
        break
      case 408:
        errormessage = '请求超时'
        break
      case 409:
        errormessage = error.response.data
        break
      case 419:
        errormessage = error.response.data
        break
      case 500:
        errormessage = '服务器内部错误'
        break
      case 501:
        errormessage = '服务未实现'
        break
      case 502:
        errormessage = '网关错误'
        break
      case 503:
        errormessage = '服务不可用'
        break
      case 504:
        errormessage = '网关超时'
        break
      case 505:
        errormessage = 'HTTP版本不受支持'
        break
      default:
    }
    Dialog.alert({
      message: errormessage
    }).then(() => {
      if (error.response.status === 401) {
        window.location.href = backUrl
      }
    })
  }
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js